/* eslint-disable */

import React from "react";

import {
  ScreenHeader,
  Container,
} from "../../components/wombat-ui";
import {
  P,
  H3,
  UList,
  H4,
} from "../../components/wombat-ui/components/Typography";

const TermsOfSale = () => {
  return (
    <>
      <ScreenHeader narrow title={"Conditions générales de vente"} />
      <Container narrow>
        <P>
          MOOVEO est un éditeur de logiciels web de gestion des ressources
          humaines, qui diffuse ses logiciels en mode Software As A Service dit
          SaaS. Le client, tel qu'identifié au Bon de Commande MOOVEO, ci-après
          désigné le « Client », s'est déclaré intéressé à utiliser le logiciel
          édité par MOOVEO en relation avec son activité professionnelle et a
          accepté à cette fin le Bon de Commande proposé par MOOVEO, ci-après
          désigné le « Bon de Commande ». Le Client a détaillé au Bon de
          Commande les modules du logiciel qu'il a choisis et objets des
          présentes Conditions générales de Vente (ci-après désignées les « CGV
          »), ci- après désigné le « Logiciel ». Le Client déclare que les
          informations qu'il a communiquées dans le Bon de Commande sont exactes
          et réelles, et s'engage à informer par écrit MOOVEO de tout changement
          à leur propos.
        </P>
        <H3>Objet – Description</H3>

        <P>
          Les présentes CGV ont pour objet la mise à disposition non exclusive
          par MOOVEO au bénéfice du Client pour ses besoins propres et
          personnels, du Logiciel en mode SaaS.
        </P>

        <P>
          Toute commande de Prestations passée auprès de MOOVEO implique
          l'acceptation sans réserve par le Client et son adhésion pleine et
          entière aux présentes Conditions Générales de Vente qui prévalent sur
          tout autre document du Client, et notamment sur toutes les conditions
          générales d'achat, sauf accord exprès et préalable de MOOVEO. Tout
          autre document que les présentes Conditions Générales de Vente et
          notamment les catalogues, prospectus, publicités et notices n'ont
          qu'une valeur informative et indicative, sans aucune valeur
          contractuelle.
        </P>

        <P>
          Les Conditions Générales de Vente constituent le socle de la
          négociation commerciale au sens de l'article L. 441-6 du Code de
          commerce et sont systématiquement adressées ou remises à chaque Client
          pour lui permettre de passer commande. Elles prévalent sur les
          conditions d'achat sauf acceptation formelle et écrite de MOOVEO.
          Toute condition contraire opposée par le Client sera, donc, à défaut
          d'acceptation expresse, inopposable à MOOVEO, quel que soit le moment
          où elle aura pu être portée à sa connaissance.
        </P>

        <P>
          Les documents applicables sont par ordre décroissant : (i) le Bon de
          Commande, (ii) les éventuelles Conditions Particulières de Vente et
          (iii) les Conditions Générales de Vente MOOVEO.
        </P>

        <P>
          Conformément à la réglementation en vigueur, MOOVEO se réserve le
          droit de déroger à certaines clauses des présentes Conditions
          Générales de Vente, en fonction des négociations menées avec le Client
          par l'établissement de Conditions Particulières de Vente et/ou du Bon
          de Commande.
        </P>

        <H3>Durée</H3>

        <P>
          Les présentes CGV prennent effet à la date de création de l'interface
          du Client pour une durée fixée au Bon de Commande (ci-après la « Date
          d'effet du contrat »). Le Contrat se renouvellera ensuite tacitement,
          de plein droit et indéfiniment par période similaire à la Période
          Initiale, sauf dénonciation par l'une ou l'autre des parties trois (3)
          mois au moins avant le terme par lettre recommandée avec accusé de
          réception (LRAR).
        </P>

        <H3>Mise en œuvre</H3>

        <P>
          Le Client déclare avoir pris connaissance de toutes informations
          techniques et fonctionnelles dès avant signature du Bon de Commande et
          des présentes CGV et déclare les accepter en l'état et sans réserves.
        </P>

        <P>
          Il revient au seul Client, à ses seuls frais et sous sa seule
          responsabilité, de se doter des moyens techniques, notamment accès
          Internet (matériel, logiciels, réseaux etc..), et de la compétence
          nécessaires pour accéder au Logiciel et effectuer toutes opérations
          permises, sans recours contre MOOVEO en cas de dommages résultant
          d'une mauvaise compréhension ou manipulation, y compris par exemple
          dans la passation ou l'annulation de commande ou encore dans
          l'effacement de données ou informations ou l'inscription de données ou
          informations incomplètes ou erronées.
        </P>

        <P>
          Le Client reconnaît avoir pris connaissance du Logiciel préalablement
          à l'acceptation des présentes CGV et avoir ainsi disposé de toute
          l'information qui lui était nécessaire, notamment pour déterminer
          l'adéquation du Logiciel à ses besoins, MOOVEO ayant fourni à son
          Client toute information et conseil préalable.
        </P>

        <P>
          Dès l'acceptation du Bon de Commande et des CGV et dans la limite de
          72h après la date d’activation prévue au Contrat, MOOVEO met en place
          le Logiciel en collaboration avec le Client, cette phase s'achevant
          par la mise à disposition de l'Espace personnel du Logiciel au Client.
          Les parties conviennent que dès cette mise à disposition, le Client
          dispose d'un délai de cinq (5) jours ouvrables pour exprimer toutes
          réserves quant à la qualité ou la conformité du Logiciel mis à
          disposition dans le cadre du Bon de Commande et des CGV. En cas de
          réserves exprimées par le Client, celles-ci, pour être recevables,
          doivent être d'une part écrites et notifiées par courriel à MOOVEO
          dans le délai précité, d'autre part précises et motivées. Le défaut
          d'une notification conforme dans les délais précités, atteste de la
          conformité du Logiciel et de l'Espace Client au Bon de Commande et aux
          CGV et de leur bonne qualité.
        </P>

        <P>
          Le Client peut solliciter de MOOVEO des prestations additionnelles,
          notamment la personnalisation du Logiciel aux couleurs et logos du
          Client ou autres. De telles prestations sont pleinement soumises au
          présentes CGV. Au titre de ces prestations, le Client s'engage à
          fournir à MOOVEO tout document décrivant de manière précise la
          prestation attendue. Aucune prestation additionnelle n'est due par
          MOOVEO si elle n'a pas préalablement et expressément été acceptée par
          MOOVEO. Les conditions financières de ces prestations seront énoncées
          dans un nouveau bon de commande établi par MOOVEO. Le Client se porte
          fort du respect des Conditions Générales d’Utilisation par les
          candidats.
        </P>

        <H3>
          Modalités d'usage du logiciel et de l'espace personnel du client
        </H3>

        <P>
          MOOVEO communique au représentant légal du Client ou à toute personne
          désignée par lui, un identifiant et un mot de passe, ci-après le «
          Code d'Accès Personnel », pour accéder à l'Espace Personnel du Client
          et utiliser le Logiciel. Le Client s'engage à modifier sans délai le
          premier Code d'Accès Personnel fourni par MOOVEO. Le Client est le
          seul gardien et responsable du Code d'Accès Personnel et il s'engage à
          ne le communiquer à aucun tiers sous quelque prétexte que ce soit, et
          à le conserver strictement confidentiel. Le Client s'engage à informer
          MOOVEO sans délai et par lettre recommandée avec accusé de réception,
          dès qu'il en aura connaissance, de tout risque d'abus ou d'utilisation
          non autorisée de son Code d'Accès Personnel.
        </P>

        <P>
          Le Client déclare à MOOVEO des utilisateurs qui, sous sa seule
          responsabilité, sont seuls habilités à accéder à la Plate-forme et à
          utiliser le Logiciel(ci-après les « Utilisateurs »). Le nombre
          d'Utilisateurs figure au Bon de Commande et peut évoluer à la hausse
          contre une augmentation du prix convenu.
        </P>

        <P>
          Le Client et ses Utilisateurs ont la faculté de modifier et d'adapter
          le paramétrage du Logiciel, cette fonctionnalité étant standard et
          représentant un des attraits majeurs du SaaS. Le Client est seul
          responsable des modifications ainsi opérées et il lui appartient de
          s'assurer que les Utilisateurs qui procéderaient à ces modifications
          sont habilités à cette fin et suffisamment formés, MOOVEO recommandant
          le suivi préalable d'une formation telle que stipulée ci-après.
        </P>

        <P>
          Les données hébergées par MOOVEO de même que l'utilisation du Logiciel
          par le Client pour ses besoins propres ou internes, sont de la seule
          responsabilité du Client. En particulier, MOOVEO ne peut être tenu
          aucunement responsable en cas d'utilisation du Logiciel avec des
          données du Client erronées produisant des résultats erronés. Le Client
          reconnait et accepte expressément que l’outil de d’évaluation des
          compétences, a pour vocation, la notation de certaines compétences
          personnelles, au titre d’une obligation de moyen et ne saurait se
          substituer à l’analyse des compétences techniques et à l’évaluation
          personnelle du candidat. En outre, le Client s'engage à ce que les
          données hébergées respectent l'ordre public et le droit des tiers. A
          défaut, et s'il a connaissance d'une infraction à la présente
          disposition, par application de la Loi n°2004-575 dite pour la
          confiance dans l'économie numérique ou Lcen, et en sa qualité
          d'hébergeur des données du Client, MOOVEO est en droit de procéder au
          retrait de toutes données incriminées, éventuellement de suspendre
          l'accès du Client au Logiciel sans autres formalités ni préavis,
          nonobstant la faculté qui lui est offerte de résilier pour faute la
          relation contractuelle sans préjudice de la possibilité de solliciter
          la réparation du préjudice subi.
        </P>

        <P>
          Le Client accepte que le Service SaaS MOOVEO, tel qu’accessible aux
          candidats, soit régi, pour ces utilisateurs, par les Conditions
          Générales d’Utilisation en Annexe 2, et la Politique de
          Confidentialité en Annexe 3, aux marques du Client et de MOOVEO.
          MOOVEO se réserve le droit d’apporter aux Conditions Générales
          d’Utilisation et à la Politique de Confidentialité toutes les
          modifications qu’elle jugera nécessaires et utiles. MOOVEO fera ses
          meilleurs efforts pour informer le Client et le candidat de
          l’existence et de l’entrée en vigueur de nouvelles conditions
          générales d'utilisation par tous moyens à sa disposition (courriers
          électroniques, information en ligne, etc.). Le Client s’engage à
          effectuer toute communication vis-à-vis des utilisateurs, et/ou toute
          transmission de données, de nature à permettre à MOOVEO d’assurer la
          défense de ses intérêts dans le cadre de son service en cas de
          violation des CGU ou de la politique de confidentialité par les
          utilisateurs.
        </P>

        <P>
          L'usage du Code d'Accès Personnel par le Client, vaut preuve de
          l'utilisation du Logiciel par le Client, la présente disposition
          valant convention de preuve au sens de l'article 1368 du Code civil
          (nouvelle numérotation par Ordonnance n°2016-131 du 10 février 2016).
          De même l'usage constant du Logiciel prouve la conformité du Logiciel.
        </P>

        <P>
          MOOVEO garantit que les données sont traitées sur le territoire de
          l'Union Européenne, ou selon des accords de protection des données
          (clauses standards de la commission Européenne ou certificat Privacy
          Shield).
        </P>

        <P>
          Le Client bénéficie, le temps de la relation contractuelle, d'un
          support à l'utilisation du Logiciel aux jours et aux heures ouvrés de
          MOOVEO, du Lundi au Vendredi de 9h à 12h et de 14h à 18h,
          exclusivement par téléphone et voie électronique, aux coordonnées
          figurant sur le page « contact » du Site, consistant en une assistance
          à l'utilisation du Logiciel par le Client. Au titre de ce support, le
          Client s'engage à une description précise de la question, du problème
          soumis.
        </P>

        <H3>Facturation et paiement</H3>

        <P>
          Le Bon de Commande prévoit les modalités financières de la relation
          entre les parties pouvant comporter notamment, le type de prestation,
          la quantité, les frais de mise en œuvre, les redevances, la
          facturation de la totalité des prestations à la date de début du
          Contrat. Le Bon de Commande dûment signé par le Client est irrévocable
          par celui-ci, sauf acceptation écrite de MOOVEO. Sauf convention
          particulière, la signature du Bon de Commande entraîne pour le Client
          acceptation des présentes Conditions Générales de Vente (CGV), la
          reconnaissance d'en avoir parfaitement connaissance et la renonciation
          à se prévaloir de ses propres conditions d'achat ou de toute autre
          disposition qui n'aurait pas été expressément accepté par MOOVEO.
        </P>

        <P>
          Conformément aux dispositions légales, le taux de TVA en vigueur sera
          appliqué à la facture établie. Tout changement du taux de TVA pourra
          être répercuté sur le prix des prestations. La facture est à payer
          dans les trente (30) jours à compter de la date de facturation.
        </P>

        <P>
          Les prix figurant sur le Bon de Commande sont indexés sur l'indice
          SYNTEC et seront automatiquement révisés à la date anniversaire du
          contrat par application de la formule suivante : P = Po x (S/So) Dans
          laquelle :
        </P>
        <UList
          items={[
            "P = montant révisé",
            "Po = montant initial",
            "So = valeur du dernier indice SYNTEC publié à la date où le présent contrat a été établi",
            "S = valeur du dernier indice SYNTEC publié à la date de révision.",
          ]}
        />
        <P>
          Si l'indice ci-dessus venait à disparaître, les Parties lui
          substitueront un indice de remplacement.
        </P>

        <P>
          Le défaut de paiement ou le retard de paiement à la date convenue par
          MOOVEO entraînera de plein droit et sans mise en demeure préalable la
          perception d'une pénalité de retard appliquée sur le montant TTC de la
          facture dont le taux de l'intérêt retenu correspond à 3 fois le taux
          de l'intérêt légal au jour de la prestation, sans préjudice du droit
          MOOVEO de suspendre la fourniture de ses prestations et/ou l'exécution
          de ses obligations jusqu'à règlement complet de la facture impayée et
          sans que cette inexécution puisse être considérée comme lui étant
          imputable. Les pénalités de retard sont exigibles sans qu'un rappel
          soit nécessaire. Elles courent de plein droit dès le jour suivant la
          date de règlement portée sur la facture. En sus des indemnités de
          retard, toute somme non payée à sa date d'exigibilité produira de
          plein droit le paiement d'une indemnité forfaitaire pour frais de
          recouvrement à MOOVEO, dont le montant est fixé à 40 euros. Lorsque
          les frais de recouvrement exposés sont supérieurs au montant de cette
          indemnité forfaitaire, MOOVEO pourra demander une indemnisation
          complémentaire sur justification de sa part. MOOVEO ne pourra
          toutefois pas invoquer le bénéfice de ces indemnités lorsque
          l'ouverture d'une procédure de sauvegarde, de redressement ou de
          liquidation judiciaire interdit le paiement à son échéance de la
          créance qui lui est due.
        </P>

        <P>
          En cas de paiement par prélèvement automatique, le Client s'engage à
          fournir un relevé d'identité bancaire en bonne et due forme lors de
          l'acceptation du Bon de Commande. Au cas où le prélèvement serait
          refusé après sa présentation en banque, pour quelque raison que ce
          soit, le Client serait redevable des frais bancaires en résultant sur
          présentation de justificatifs par MOOVEO. En cas de paiement par
          chèque, et au cas où le chèque serait refusé après sa présentation en
          banque, pour quelque raison que ce soit, le Client serait redevable
          des frais bancaires en résultant sur présentation de justificatifs par
          MOOVEO.
        </P>

        <H3>Accord de niveaux de service (SLA), garanties et responsabilité</H3>

        <P>
          MOOVEO s'engage à assurer un accès au Logiciel 24 heures sur 24 et 7
          jours sur 7, avec une disponibilité de 99,7%, sous réserve des
          interventions de maintenance préventive, que MOOVEO s'engage à
          réaliser à des heures creuses, c'est-à-dire où l'utilisation du
          Logiciel est minimale, et sauf cas de force majeure. En cas
          d'interruption de l'usage du Logiciel par la seule faute de MOOVEO,
          MOOVEO s'engage à indemniser le Client si celui-ci, d'une part, en
          fait la demande écrite par courriel à l'adresse contact@mooveo.co dans
          un délai de trois jours ouvrés après l'incident, d'autre part, s'il
          prouve avoir subi un préjudice réel, direct et personnel. Dans cette
          hypothèse, en cas d'indisponibilité inférieure à 4 heures, MOOVEO
          indemnise le Client par l'octroi d'un remboursement d'un montant
          représentant 1/5ème du montant mensuel dû par le Client à MOOVEO ; si
          l'indisponibilité dépasse 4 heures, le montant s'élève à la moitié du
          montant mensuel dû par le Client à MOOVEO ; et si l'indisponibilité
          est supérieure à 48 heures, le montant de la pénalité libératoire sous
          forme de remboursement se monte au montant mensuel entier dû par le
          Client à MOOVEO.
        </P>

        <P>
          MOOVEO sera dégagé de tout ou partie de sa responsabilité découlant de
          l'article 6.1 et le Client l'accepte expressément, en apportant la
          preuve que l'inexécution ou la mauvaise exécution de la relation
          contractuelle est imputable soit au Client lui-même, soit au fait
          imprévisible et insurmontable d'un tiers étranger à la fourniture des
          services convenus, soit à un cas de force majeure. Outre ceux
          habituellement reconnus par la jurisprudence des cours et tribunaux
          français, sont notamment assimilés à des cas de force majeure ou
          fortuits déchargeant MOOVEO de ses obligations au titre des présentes
          Conditions générales de Vente : les grèves de la totalité ou d'une
          partie du personnel de MOOVEO, de ses éventuels sous-traitants ou de
          tout tiers dont l'intervention serait requise pour les prestations,
          blocage des moyens de transport ou d'approvisionnement, les cas
          d'incendie, d'inondation, de tempête, de foudre, de guerre, d'émeute,
          d'insurrection, de saisie, d'embargo, de restrictions d'énergie, de
          restrictions monétaires ou d'exportation, de catastrophe naturelle,
          d'acte de terrorisme de barrage routier, de gel, d'épidémie ; les
          arrêts des réseaux de télécommunication ou les difficultés propres aux
          réseaux de télécommunication externe au Client ou à MOOVEO. Dans de
          telles circonstances, MOOVEO préviendra le Client dans les meilleurs
          délais et par écrit, notamment par télécopie ou courrier électronique.
          La relation contractuelle est alors suspendue de plein droit sans
          indemnité, à compter de la date de survenance de l'événement. Si
          l'événement venait à durer plus de trente (30) jours à compter de la
          date de sa survenance, la relation contractuelle nouée par MOOVEO et
          le Client pourra être résiliée par la partie la plus diligente, sans
          que le Client puisse prétendre à l'octroi de dommages et intérêts.
          Cette résiliation prendra effet à la date de la première présentation
          de la lettre recommandée avec accusé de réception dénonçant ladite
          relation contractuelle. Les sommes versées à MOOVEO par le Client
          antérieurement à la date de survenance de l'événement de force majeure
          à l'origine de la résiliation de la relation contractuelle lui
          resteront intégralement acquises.
        </P>

        <P>
          En cas de manquement de MOOVEO à ses obligations contractuelles, sa
          responsabilité ne saurait être recherchée au-delà d'un an à compter de
          la survenance du fait générateur de celle-ci et sous réserve de
          respecter les stipulations prévues aux articles 9 et 16 des présentes
          Conditions Générales de Vente, et seulement en cas de faute prouvée.
          Dans tous les cas, MOOVEO ne garantit aucun dommage indirect, ni aucun
          préjudice découlant d'une éventuelle perte de chiffre d'affaires ou
          d'activité, la responsabilité de MOOVEO étant en tout état de cause
          limitée à six mois du prix de l'abonnement payé par le Client dans le
          cadre des présentes CGV.
        </P>

        <P>
          Le Client déclare être un professionnel, et s'engage à utiliser le
          Logiciel et l'Espace Client conformément aux instructions de MOOVEO.
          Le Client s'engage à réserver l'Espace Personnel du Client à une
          utilisation en rapport avec le Logiciel à l'exclusion de toute autre
          utilisation.
        </P>

        <H3>Propriété intellectuelle et industrielle</H3>

        <P>
          Les présentes CGV ne transfèrent aucun droit de propriété ou privatif
          d'aucune sorte au Client au titre du Logiciel, de l'Espace Client,
          sauf le droit d'usage en tant qu'utilisateur final pour ses besoins
          propres et personnels, durant le temps du présent Contrat du Logiciel,
          et de l'Espace Client dans le strict cadre du présent Contrat.
        </P>

        <P>
          Le Client déclare être titulaire des droits portant sur les données
          hébergées par MOOVEO dans le cadre du présent Contrat et il garantit
          et indemnisera à première demande MOOVEO de tous dommages, coûts,
          dépenses y compris le coût (frais et honoraires) de sa défense, MOOVEO
          ayant le choix de son défenseur, amendes ou indemnités de toute nature
          que MOOVEO subirait du fait d'une réclamation de tiers, y compris
          toute autorité administrative compétente, à raison d'un manquement du
          Client à l'égard des obligations qui lui incombent au titre des
          dispositions du présent article.
        </P>

        <P>
          Le Client autorise expressément MOOVEO à le faire figurer comme l'une
          de ses références commerciales et à faire usage de la dénomination et
          logo du Client à ce titre sur le Site, ainsi que dans tous ses
          supports et documents de communication et de marketing (réseaux
          sociaux, blog, communiqué de presse, retours d'expérience, ...).
        </P>

        <P>
          En cas de commande par le Client d'une prestation de personnalisation
          du Logiciel, il concède par les présentes à MOOVEO, au titre de ces
          travaux, le droit de reproduire tous logos, marques, signes
          distinctifs de toute sorte dont il déclare être titulaire d'un droit
          privatif au sens du Code de la propriété intellectuelle, et pour
          lesquels il apporte à MOOVEO la même garantie que celle stipulée à
          l'article 7.2. ci avant.
        </P>

        <H3>Protection et gestion des données personnelles</H3>

        <P>
          Dans le cadre de leurs relations contractuelles, les Parties
          s'engagent à respecter la réglementation en vigueur applicable au
          traitement de données à caractère personnel et, en particulier, le
          règlement (UE) 2016/679 du Parlement européen et du Conseil du 27
          avril 2016 applicable à compter du 25 mai 2018.
        </P>

        <H4 className="pl-10">MOOVEO en qualité de sous-traitant :</H4>

        <P className="pl-10">
          Le Client est responsable de traitement des données personnelles
          traitées par les différentes fonctionnalités disponibles en SaaS,
          MOOVEO assurant un rôle de sous-traitant, à l’exception de la
          Recherche et développement sur ses produits et services, au titre
          duquel MOOVEO agit en qualité de responsable de traitement.
        </P>

        <P className="pl-10">
          Les dispositions prises à cet égard sont détaillées en Annexe 1, qui
          précise dans quels cas MOOVEO agit en qualité de sous-traitant et dans
          quels cas MOOVEO agit en qualité de responsable de traitement.
        </P>

        <P className="pl-10">
          Pour toute question relative à la protection des données à caractère
          personnel, MOOVEO met à la disposition de ses Clients une politique de
          protection des données personnelles dont les caractéristiques sont
          explicitées dans la Politique de Confidentialité accessible en Annexe
          3.
        </P>

        <H3>Clause résolutoire</H3>

        <P>
          Chaque Partie pourra mettre fin à la relation contractuelle en cas de
          manquement de l'autre partie à une disposition essentielle des
          présentes CGV, et un mois après une mise en demeure adressée par
          lettre recommandée avec accusé de réception à l'autre partie, exposant
          le ou les griefs de manière détaillée et visant la disposition des CGV
          concernées, et ce en application des dispositions de l'article 1224 du
          Code civil. En cas de résiliation pour faute du Client par MOOVEO,
          cette résiliation entraîne automatiquement et de plein droit la
          déchéance du terme pour toutes autres sommes dues par le Client à
          MOOVEO, qui deviennent payables immédiatement, même avant la date
          d'échéance convenue, sans préjudice de tous dommages et intérêts
          supplémentaires auxquels il pourrait prétendre notamment au titre de
          la perte de marge résultant de la défaillance du Client. MOOVEO
          pourra, à sa discrétion, résilier toutes les autres commandes du
          Client, qu'elles aient été exécutées ou en cours d'exécution.
        </P>

        <H3>Formation</H3>

        <P>
          MOOVEO recommande la formation des Utilisateurs du Client au Logiciel.
          La formation des Utilisateurs est réalisée par MOOVEO dès que le
          Logiciel est opérationnel, à distance, aux jours et aux heures ouvrées
          MOOVEO. Les objectifs de la formation sont d'accompagner les
          Utilisateurs dans la prise en main du Logiciel, c'est-à-dire constitue
          une aide aux Utilisateurs mais ne doit aucunement aboutir à substituer
          MOOVEO au Client dans l'utilisation du Logiciel. La formation peut
          s'accompagner de la remise de supports ou de tutoriels vidéos, remis
          par MOOVEO au Client, qui restent la propriété pleine et entière de
          MOOVEO et ne peuvent aucunement être reproduits ou représentés en
          dehors de la formation par le Client et ses Utilisateurs.
        </P>

        <P>
          Sur demande du Client, des formations sur site peuvent être dispensées
          par MOOVEO, les modalités de la formation en présence faisant alors
          l'objet d'une convention spéciale entre les Parties, aux conditions
          tarifaires en vigueur de MOOVEO à la date de la commande, frais de
          déplacement, d'hébergement et de restauration le cas échéant, en sus.
        </P>

        <H3>Divers</H3>

        <P>
          Le savoir-faire de MOOVEO, y compris le fonctionnement du Logiciel et
          de l'Espace Client, est strictement confidentiel et réservé au seul
          usage du Client à l'exclusion de tout tiers. Les données fournies par
          le Client et hébergées par MOOVEO dans le Logiciel sont et restent la
          propriété pleine et entière du Client et MOOVEO s'engage à les
          conserver strictement confidentielles.
        </P>

        <P>
          Tout document fourni par le Client à MOOVEO tel que notamment,
          expression de besoins, étude, cahier des charges, est, même si MOOVEO
          y a répondu, dénué de tout caractère contractuel et n'entre pas dans
          le champ des présentes CGV, lequel a pour objet la mise à disposition
          dans les conditions rappelées ci-avant, d'un Logiciel standard que le
          Client doit évaluer pour s'assurer qu'il est adapté à ses besoins.
        </P>

        <P>
          Le Client ne peut aucunement céder les droits issus des présentes, ni
          partiellement, ni en totalité, ni mettre à disposition de quiconque,
          même à titre temporaire, quelle que soit l'opération juridique, le
          Logiciel, le Site, l'Espace Client.
        </P>

        <H3>Tolérances</H3>

        <P>
          Il est formellement convenu que toute tolérance ou renonciation d'une
          des Parties, dans l'application de tout ou partie des engagements
          prévus aux présentes Conditions Générales de Vente, quelles qu'en
          aient pu être la fréquence et la durée, ne saurait valoir modification
          des Conditions Générales de Vente, ni générer un droit quelconque.
        </P>

        <H3>Indépendance des stipulations</H3>

        <P>
          Les stipulations des présentes Conditions Générales de Vente sont
          indépendantes les unes des autres. En conséquence, dans le cas où
          l'une d'entre elles serait réputée non écrite par une quelconque
          décision judiciaire, ou rendue non valide en application d'une loi ou
          d'un règlement, les autres stipulations, y compris celles faisant
          référence à la stipulation annulée, continueront de régir les
          relations entre MOOVEO et le Client et garderont toute leur force et
          leur portée entre les Parties.
        </P>

        <H3>Droit applicable – Langue du Contrat</H3>

        <P>
          De convention expresse entre les Parties, tout litige relatif à
          l'interprétation et à l'exécution des présentes Conditions Générales
          de Vente est soumis au droit français, à l'exclusion de toute autre
          législation. Elles sont rédigées en langue française, dans le cas où
          il serait traduit en une ou plusieurs langues, seul le texte français
          ferait foi en cas de litige.
        </P>

        <H3>Règlement des différends</H3>

        <P>
          En cas de litige sur son interprétation et / ou exécution, et sauf le
          cas d'impayé qui autorise la saisine directe du Tribunal compétent,
          les Parties conviennent de tenter de trouver le règlement amiable du
          litige dans un délai d'un mois, la Partie la plus diligente invitant
          l'autre par lettre recommandée avec accusé de réception détaillant le
          ou les griefs et les dispositions contractuelles qu'elle considère
          violées, à une réunion devant se tenir à l'adresse du siège social de
          MOOVEO, dans un délai minimal de cinq jours ouvrés.
        </P>

        <P>
          En cas d'échec de la tentative de règlement amiable, le litige sera
          soumis exclusivement au Tribunal de Commerce de Paris, nonobstant
          appels en garantie ou pluralité de défendeurs, y compris pour les
          mesures d'urgence ou conservatoires.
        </P>

        <H3>Acceptation du Client</H3>

        <P>
          Les présentes conditions générales de vente ainsi que les tarifs sont
          expressément agréés et acceptés par le Client, qui déclare et
          reconnaît en avoir une parfaite connaissance, et renonce, de ce fait,
          à se prévaloir de tout document contradictoire et, notamment, ses
          propres conditions générales d'achat.
        </P>

        <P>
          Le Client reconnait que, en cas de mise à jour ou modification des
          CGV, toute nouvelle demande d’intervention ou commande entrainera
          l’application des nouvelles conditions générales de vente mises à jour
          pour autant qu’elles aient été portées à la connaissance du Client par
          quelque moyen que ce soit.
        </P>
      </Container>
    </>
  );
};

export default TermsOfSale;
